import { render, staticRenderFns } from "./mediaLink.vue?vue&type=template&id=65412014&"
import script from "./mediaLink.vue?vue&type=script&lang=js&"
export * from "./mediaLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports